export default (state = [], action) => {
  switch (action.type) {
    case 'MIGRATION_SECURITY_STATUS':
      return action.payload;
    default:
      return state;
  }
};
